var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('balance',{attrs:{"title":"تراز حساب ها","cols":_vm.datatableCols,"url":"reports/balance","getAccountLedgerQuery":_vm.getAccountLedgerQuery,"getSubAccountLedgerQuery":_vm.getSubAccountLedgerQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }